import { render, staticRenderFns } from "./versionForm.vue?vue&type=template&id=3b76d85a&"
import script from "./versionForm.vue?vue&type=script&lang=js&"
export * from "./versionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports